import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

interface BreadcrumbItem {
    label: string;
    icon?: string;
    path?: string;
}

export const useBreadcrumb = (): BreadcrumbItem[] => {
    const location = useLocation();

    const breadcrumbs = useMemo(() => {
        const pathSegments = location.pathname.split('/').filter(Boolean);
        const items: BreadcrumbItem[] = [
            { label: 'Admin', icon: 'pi pi-home', path: '/admin' }
        ];

        // Map routes to breadcrumb items
        const routeMap: Record<string, BreadcrumbItem> = {
            'dashboard': { label: 'Dashboard', icon: 'pi pi-chart-bar' },
            'trips': { label: 'Quản lý chuyến đi', icon: 'pi pi-map' },
            'drivers': { label: 'Quản lý tài xế', icon: 'pi pi-users' },
            'inactive': { label: 'Tài xế chưa kích hoạt', icon: 'pi pi-clock' },
            'active': { label: 'Tài xế đã kích hoạt', icon: 'pi pi-check-circle' },
            'users': { label: 'Quản lý người dùng', icon: 'pi pi-user-plus' },
            'notifications': { label: 'Quản lý thông báo', icon: 'pi pi-bell' },
            'vouchers': { label: 'Quản lý Voucher', icon: 'pi pi-ticket' },
            'public': { label: 'Voucher chung', icon: 'pi pi-gift' },
            'private': { label: 'Voucher riêng', icon: 'pi pi-tag' },
            'roles': { label: 'Quản lý phân quyền', icon: 'pi pi-shield' },
            'admins': { label: 'Quản lý admin', icon: 'pi pi-cog' },
            'pricing': { label: 'Quản lý giá cả', icon: 'pi pi-money-bill' },
            'motorbike': { label: 'Giá xe máy', icon: 'pi pi-circle' },
            'car-4seat': { label: 'Giá xe ô tô 4 chỗ', icon: 'pi pi-car' },
            'car-7seat': { label: 'Giá xe ô tô 7 chỗ', icon: 'pi pi-truck' }

        };

        // Build breadcrumb from path segments
        let currentPath = '';
        pathSegments.forEach((segment, index) => {
            if (segment === 'admin') return; // Skip admin segment as it's already added

            currentPath += `/${segment}`;
            const fullPath = `/admin${currentPath}`;

            const breadcrumbItem = routeMap[segment];
            if (breadcrumbItem) {
                items.push({
                    ...breadcrumbItem,
                    path: index === pathSegments.length - 1 ? undefined : fullPath // Last item has no path (current page)
                });
            }
        });

        return items;
    }, [location.pathname]);

    return breadcrumbs;
};

export default useBreadcrumb;
